<template>
  <v-dialog
    v-model="dialog"
    width="60%"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :class="btnClass"
        :text="text"
        :outlined="outlined"
        :small="small"
        :depressed="depressed"
        v-on="on"
      >
        <slot />
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Visualizations browser
      </v-card-title>
      <v-card-text class="pr-5">
        <v-autocomplete
          v-model="selectedQuery"
          clearable
          placeholder="Select a query"
          :items="selectableQueries"
          label="Browse queries"
          persistent-hint
          prepend-icon="mdi-city"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-title>
                You queries list is empty, <router-link
                  class="success--text"
                  :to="`/projects/${project}/create/query`"
                >
                  create a new query
                </router-link>.
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-autocomplete>
        <v-row

          v-if="visualizations.length > 0"
        >
          <v-col cols="12">
            <p>
              Choose the visualization your want to include in your dashboard
              <v-btn
                v-if="_.find(visualizations,v=>{return v.selected})"
                class="float-right"
                small
                text
                @click="clearSelected"
              >
                Clear selection
              </v-btn>
            </p>
          </v-col>
          <v-col
            v-for="(e, e_index) in visualizations"
            :key="e_index"
            class="mr-3 mb-3"
            cols="2"
          >
            <v-card
              style="cursor:pointer;"
              :class="{selected : e.selected}"
              class="text-center pt-3"
              @click="handleVisualizationSelection(e)"
            >
              <v-icon style="font-size:50px;">
                {{ decideElementIcon(e.type) }}
              </v-icon>
              <div class="mt-1">
                <strong class="text-capitalize">{{ e.type }}</strong>
              </div>
              <div :class="{'white--text':e.selected,'text-truncate pl-3 pr-3 pt-2 pb-4':true}">
                {{ e.label }}
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click.native="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="selectedVisualizations.length <= 0"
          @click.native="addVisualizations"
        >
          Add visualization
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import HELPER from './helpers/helper'
  import QueryService from './services/QueryService'
  export default {
    mixins: [HELPER],
    props: {
      btnClass: {
        type: String,
        required: false,
        default: () => { return '' },
      },
      small: {
        type: Boolean,
        required: false,
        defautl: () => { return false },
      },
      depressed: {
        type: Boolean,
        required: false,
        defautl: () => { return false },
      },
      text: {
        type: Boolean,
        required: false,
        defautl: () => { return false },
      },
      outlined: {
        type: Boolean,
        required: false,
        defautl: () => { return false },
      },
    },
    data () {
      return {
        dialog: false,
        queries: [],
        selectedQuery: '',
      }
    },
    computed: {
      project () {
        return this.$route.params.project
      },
      selectableQueries () {
        return _.map(this.queries, 'name')
      },
      selectedVisualizations () {
        const els = _.flatten(_.map(this.queries, 'visualizations'))
        return _.filter(els, e => { return e.selected })
      },
      visualizations () {
        const self = this
        if (this.selectedQuery == '') { return [] } else {
          const q = _.find(this.queries, q => { return q.name == self.selectedQuery })
          if (q) { return q.visualizations } else { return [] }
        }
      },
    },
    mounted () {
      this.getQueries()
    },
    methods: {
      clearSelected () {
        _.map(this.visualizations, v => { v.selected = false })
      },
      getQueries () {
        const self = this
        QueryService.list(this).then(res => {
          _.map(res.data.results, q => {
            _.map(q.visualizations, e => {
              e.selected = false
            })
          })
          self.queries = res.data.results
        })
      },
      addVisualizations () {
        this.$emit('add', this.selectedVisualizations)
        this.resetSelection()
        this.dialog = false
      },
      resetSelection () {
        _.map(this.queries, q => {
          _.map(q.visualizations, e => {
            e.selected = false
          })
        })
      },
      handleVisualizationSelection (e) {
        this.$set(e, 'selected', !e.selected)
      },
    },
  }
</script>

<style scoped>
.selected > i{color:white !important;}
.selected {
    color:white;
    background-color:#00A390;
}
</style>
